export default __webpack_public_path__ + "static/media/CNo.76-1.33d6f18c.jpg";